var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 2,
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2H9C9.28333 2 9.52083 1.90417 9.7125 1.7125C9.90417 1.52083 10 1.28333 10 1C10 0.716667 9.90417 0.479167 9.7125 0.2875C9.52083 0.0958337 9.28333 0 9 0H1C0.716667 0 0.479167 0.0958337 0.2875 0.2875C0.0958332 0.479167 0 0.716667 0 1C0 1.28333 0.0958332 1.52083 0.2875 1.7125C0.479167 1.90417 0.716667 2 1 2Z",
    fill: "white"
  })));
};
export default SvgMinus;